import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '@/lib/firebase';

const MAX_EVIDENCE_BYTES = 25 * 1024 * 1024;

export async function uploadReportEvidence(
  files: File[],
  userId: string,
): Promise<string[]> {
  const urls: string[] = [];
  for (const file of files) {
    if (file.size > MAX_EVIDENCE_BYTES) {
      throw new Error(`${file.name} is over 25 MB.`);
    }
    const path = `reports/${userId}/${Date.now()}-${file.name}`;
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    urls.push(await getDownloadURL(storageRef));
  }
  return urls;
}
